import { actionTypesEnum } from '../enum';

export const tipoCambioDolar = (state = null, action) => {

    if(action.type === actionTypesEnum.tipoCambioDolar){
        return action.payload;
    }

    return state;
}